/******************************************************************************
 * 
 * Strauss Motion
 * 
 * Copyright (c) 2022 Robimo GmbH
 *
 * Authors: Daniel Martinek
 *
 *****************************************************************************/

import { connect } from 'react-redux'
import { ApplicationState } from '../store/interfaces';

import { Splashscreen } from '../components/Splashscreen'
import { configClear, configGetFetch, configStoreFetch, uiGoTo, uiSetCode } from '../store/actions';

const mapStateToProps = (state: ApplicationState) => {
    return {
        ui: state.ui,
        library: state.library
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        onUiSetCode: (code: string) => {
            dispatch(uiSetCode(code));
        },
        onUiGoTo: (route: string) => {
            dispatch(uiGoTo(route));
        },
        onUiStartNew: () => {
            dispatch(configClear());
            dispatch(configStoreFetch());
            dispatch(uiGoTo('editscreen'));
        },
        onGetConfig: () => {
            dispatch(configGetFetch());
        }
    }
}

const SplashscreenContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(Splashscreen)

export default SplashscreenContainer